module.exports = __webpack_public_path__ + "img/introTopImg.82326ca5.jpg";